import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  private lastVisitedUrl: string = '/';

  constructor(private router: Router, private injector: Injector) {

    this.router.events.subscribe(event => {

      if (event instanceof NavigationEnd) {

        this.lastVisitedUrl = event.urlAfterRedirects || this.router.url;
      }
    });
  }

  handleError(error: any): void {

    // Detect ChunkLoadError
    if (error instanceof Error && error.name === 'ChunkLoadError') {

      // Show a native browser confirmation dialog
      const shouldReload = confirm('A new version of the app is available. Reload now to update?');

      if (shouldReload) {
        // Reload the page to get the latest version
        this.reloadLastVisitedPage();
      }
    }
  }

  private reloadLastVisitedPage(): void {

    // Try to navigate to the last visited URL
    this.router.navigateByUrl(this.lastVisitedUrl).then(success => {

      if (!success) {

        // If navigation fails, fall back to a full reload
        location.reload();
      }
    }).catch(err => {

      // Handle any unexpected errors during navigation
      location.reload(); // Fallback to full reload
    });
  }
}
